




































































































































import { Device } from '@/types/device'

import ToolbarSave from '@/components/icons/toolbar-save.vue'
import ToolbarRefresh from '@/components/icons/toolbar-refresh.vue'
import ToolbarDelete from '@/components/icons/toolbar-delete.vue'

import mixin from './Mixin'

export default mixin.extend({
  components: {
    ToolbarSave,
    ToolbarRefresh,
    ToolbarDelete,
  },
  data() {
    return {
      fields: [
        {
          key: 'id',
          label: 'ID',
          thStyle: { width: '30px' },
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        { key: 'name' },
        { key: 'driver', thStyle: { width: '200px' } },
        {
          key: 'enabled',
          thStyle: { width: '50px' },
          tdClass: 'text-center',
        },
        'description',
      ],
    }
  },
  methods: {
    // eslint-disable-next-line
    // handleContextMenu($event: any, device: Device) {
    //   this.selected(device)
    //   // eslint-disable-next-line
    //   ;(this as any).$refs.contextMenu.open($event)
    // },

    handleRowClicked(item: Device, index: number) {
      this.$emit('row-clicked', item, index)
    },

    selected(device: Device) {
      this.selectedDevice = device
      this.$emit('seleced-changed', device)
    },

    async onNewRowEnterKeyUp() {
      this.newDevice.config = this.drivers[this.newDevice.driver].default
      await this.createDevice()
    },

    // -------------------------------------------------------------------------------------------
    // Toolbars
    // -------------------------------------------------------------------------------------------
    async onToolbarRefrech() {
      await this.FindDrivers()
      await this.findDevice()
    },
    async onToolbarSave() {
      this.patch(this.selectedDevice.id, this.selectedDevice)
      this.findDevice()
    },

    onToolbarDelete() {
      // eslint-disable-next-line
      ;(this as any).$refs.dialogDelete.show()
    },

    onToolbarConnect() {
      this.putConnect()
    },
    onToolbarDisconnect() {
      this.putDisconnect()
    },
  },
  async created() {
    await this.findDevice()
  },
})
